(() => {
  const swiper = new Swiper(".corporate-testimonial .swiper", {
    loop: true,
    pagination: {
      el: ".corporate-testimonial .swiper-pagination",
    },
    navigation: {
      addIcons: false,
      nextEl: ".corporate-testimonial .swiper-button-next",
      prevEl: ".corporate-testimonial .swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });
})();
